import { render } from "./AddNewMemberToGroup.vue?vue&type=template&id=49acb3a1&scoped=true"
import script from "./AddNewMemberToGroup.vue?vue&type=script&lang=js"
export * from "./AddNewMemberToGroup.vue?vue&type=script&lang=js"

import "./AddNewMemberToGroup.vue?vue&type=style&index=0&id=49acb3a1&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49acb3a1"]])

export default __exports__